const APIVariables = {
  // Dropdowns
  HCP_HOSPITALS: "/hcp/hospitals/list",
  HCP_PHARMACY_INSTITUTIONS: "/hcp/pharmacy/institutions",
  HCP_PHARMACY: "/hcp/pharmacy/list",
  HCP_PHARMACIES_LIST_PRESCRIPTIONS: "/hcp/pharmacies/list/prescription",
  HCP_CONNECTED_NURSES: "/hcp/connected/nurses",
  HCP_CONNECTED_REGISTRARS: "/hcp/connected/registrars",
  HCP_CONNECTED_NURSE: "/hcp/connected/nurses/",
  HCP_CONNECTED_REGISTRAR: "/hcp/connected/registrars/",
  HCP_CONNECTED_NURSES_DELETE: "/hcp/connected/nurses/",
  HCP_CONNECTED_REGISTRARS_DELETE: "/hcp/connected/registrars/",
  HCP_CONNECTED_NURSES_EDIT: "/hcp/connected/nurses/edit/",
  HCP_CONNECTED_REGISTRARS_EDIT: "/hcp/connected/registrars/edit/",

  // Authentication
  USERS_SIGNUP_PHARMACY: "/users/signup/pharmacy/",
  USERS_SIGNUP_PRESCRIBER: "/users/signup/prescriber/",
  USERS_ACTIVATE: "/users/activate",
  USERS_PASSWORD_RESET: "/users/password-reset/",
  USERS_PASSWORD_RESET_GET_EMAIL: "/users/password-reset/resolve/",
  USERS_LOGIN: "/users/login",
  USERS_LOGOUT: "/users/logout",
  USERS_PROFILE: "/users/profile",
  USERS_PROFILE_PRESCRIBER_EDIT: "/users/profile/prescriber/edit/",
  USERS_PROFILE_NURSE_EDIT: "/users/profile/nurse/edit/",
  USERS_PROFILE_REGISTRAR_EDIT: "/users/profile/registrar/edit/",
  USERS_PROFILE_PHARMACY_EDIT: "/users/profile/pharmacy-user/edit/",

  PATIENT_STATISTICS: "/patients/statistics",
  PATIENTS_BROCHURES: "/patients/brochures",
  PATIENTS_BROCHURES_DOWNLOAD: "/patients/brochures/download/",
  PATIENTS_DETAILS: "/patients/",
  PATIENTS_LIST: "/patients/list",

  USERS_SIGNUP_CONNECTED_NURSES: "/users/signup/connected-nurse/",
  USERS_SIGNUP_CONNECTED_REGISTRARS: "/users/signup/connected-registrar/",
  USERS_SIGNUP_PATIENT_MALE: "/users/signup/patient/male/",
  USERS_SIGNUP_PATIENT_WOMAN_NCP: "/users/signup/patient/woman-ncp/",
  USERS_SIGNUP_PATIENT_WOMAN_CP: "/users/signup/patient/woman-cp/",

  USERS_SIGNUP_PATIENTS_MALE: "/users/signup/patient/male/",
  USERS_SIGNUP_PATIENTS_WOMAN_CP: "/users/signup/patient/woman-cp/",

  USERS_PASSWORD_VALIDATE: "/users/password/validate",

  USERS_REREGISTRATION: "/users/re-registration/",

  PRESCRIPTIONS_FILTERS: "/prescriptions/filters",
  PRESCRIPTIONS_NOTIFICATIONS: "/prescriptions/notifications",
  PRESCRIPTIONS_NOTIFICATIONS_COUNT: "/prescriptions/notifications/count",
  PRESCRIPTIONS_NOTIFICATIONS_READ: "/prescriptions/notifications/read/",
  PRESCRIPTIONS_PAPER_CREATE_POST: "/prescriptions/paper/create",
  PRESCRIPTIONS_CREATE_POST: "/prescriptions/create",

  //PRESCRIPTIONS
  PRESCRIPTIONS: "/prescriptions/",
  PRESCRIPTIONS_PATIENTS: "/prescriptions/patients/",
  PRESCRIPTIONS_CREATE: "create",
  PRESCRIPTIONS_RENEW: "/renew",
  PRESCRIPTIONS_ACCEPT: "/prescriptions/accept/",
  PRESCRIPTIONS_REJECT: "/prescriptions/reject/",
  PRESCRIPTIONS_GET: "/prescriptions/",

  // ORDERS
  ORDERS_CREATE: "/orders/create",
  ORDERS_EDIT: "/orders/edit/",
  ORDERS_VIEW: "/orders/view/",
  MAHS: "/orders/mah/list",
  CONTACT_US: "/orders/mah/contact-us",
  REPORT_ADVERSE: "/orders/mah/report-adverse-event",

  // DOWNLOAD
  DOWNLOAD_PAF: "/patients/paf/download/",

  RELEASE_NOTES_LIST: "/release-notes/list",
  RELEASE_NOTES_READ: "/release-notes/read",
};

export default APIVariables;
